import type { Action, ActionConfig, ActionRegistry } from "../actions.types";
import { getConfig } from "./getConfig";

/**
 * Get config from registry by action.
 */
export function getConfigForAction(
  registry: ActionRegistry,
  action: Action
): ActionConfig | undefined {
  const slug = action.action_type?.slug;
  if (!slug) return undefined;
  return getConfig(registry, slug);
}

